/* istanbul ignore file */
import FavoritesLimitReachedDialog from '@ms/yammer-web-components/dist/group/FavoritesLimitReachedDialog';
import { LoadableShareDraftFromPublisherDialogHost } from '@ms/yammer-web-components/dist/publisher/SaveAsDraft/LoadableShareDraftFromPublisherDialogHost';
import { LoadableUsagePolicyDialog } from '@ms/yammer-web-components/dist/usagePolicy/UsagePolicyDialog';
import type { FC } from 'react';
import React from 'react';

import FirstRunExperience from '../FirstRunExperience';

const Dialogs: FC = () => (
  <>
    <FirstRunExperience />
    <LoadableUsagePolicyDialog />
    <FavoritesLimitReachedDialog />
    <LoadableShareDraftFromPublisherDialogHost />
  </>
);

export default Dialogs;
